import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Pending = new StatusEnumItem({
  id: 'EEA01EDD-DE41-4231-8FB8-7BCF0908F10A',
  name: 'Pending',
  description: 'The job has been requested and is waiting to be processed',
  priority: 0,
})
const Processing = new StatusEnumItem({
  id: '5CA52FAA-762A-4A2A-832E-6E005FD029D5',
  name: 'Processing',
  description: 'The job is currently processing',
  priority: 1,
})
const Completed = new StatusEnumItem({
  id: '07F7B47A-21E2-4BE6-932B-0602C6590E86',
  name: 'Completed',
  description: 'The job has completed',
  priority: 2,
})
const Failed = new StatusEnumItem({
  id: '499FF0F9-5BC9-4311-97BE-BCFB01FA8FA2',
  name: 'Failed',
  description: 'The job failed to complete',
  priority: 3,
})

export type JobStatusItem =
  | typeof Pending
  | typeof Processing
  | typeof Completed
  | typeof Failed

class JobStatusEnum extends StatusEnum<
  'JobStatus',
  JobStatusItem,
  JobStatusItem['name'],
  JobStatusItem['id'],
  JobStatusItem['priority']
> {
  readonly typename = 'JobStatus'
  get values() {
    return [this.Pending, this.Processing, this.Completed, this.Failed]
  }
  Pending = Pending
  Processing = Processing
  Completed = Completed
  Failed = Failed
}

/**
 * a {@link StatusEnum} for JobStatus entities
 */
export const JobStatus = new JobStatusEnum()
